<template>
  <iframe src="/app#/gismobile" frameborder="0" style="width:100%; height: calc(100vh - 60px);"></iframe>
</template>

<script>
  export default {}
</script>
